module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fcWyr"))).then(() => parcelRequire('d0iPb'));